import { speciesGetAllForDropdown } from "@/api/species";

const state = {
    speciesOptions: null
};

const mutations = {
    GET_ALL_OPTIONS: (state, data) => {
        state.speciesOptions = data;
    },
};

const actions = {
    async speciesGetAllForDropdown({ commit }) {
        let res = await speciesGetAllForDropdown();
        if (res) {
            commit("GET_ALL_OPTIONS", res); 
        }
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};




// WEBPACK FOOTER //
// ./src/vuex/modules/species.js